import { Tooltip } from 'antd';
import { Dispatch, SetStateAction, useState } from 'react';

type Props = {
  setParams: Dispatch<SetStateAction<string | null>>;
  setRefetch: Dispatch<SetStateAction<boolean>>;
  placeHolder?: string;
  param: string | null;
  disabled?: boolean;
};
export const CustomSearchBar = ({
  setParams,
  setRefetch,
  placeHolder,
  disabled = false,
}: Props) => {
  const [search, setSearch] = useState<string>('');
  const handleSearch = (value: string) => {
    setSearch(value);
    setParams(value === '' ? null : value);
    setRefetch(refetch => !refetch);
  };
  const minimumPlaceholderLength = 23;

  return (
    <div className="flex gap-[15px] items-center">
      <label>Search:</label>
      <Tooltip
        title={
          !disabled &&
          placeHolder &&
          placeHolder.length > minimumPlaceholderLength
            ? placeHolder
            : null
        }
      >
        <div className="flex items-center gap-[10px]">
          <input
            placeholder={placeHolder}
            value={search}
            type="text"
            onChange={e => handleSearch(e.target.value)}
            disabled={disabled}
            className="h-[40px] w-[250px] bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
          />
        </div>
      </Tooltip>
    </div>
  );
};
